import React from 'react';
import { Calendar } from 'lucide-react';

export interface CustomDateRange {
  start: string;
  end: string;
}

interface CustomDateSelectorProps {
  filterId: string;
  customDates: Record<string, CustomDateRange>;
  updateCustomDate: (id: string, field: 'start' | 'end', value: string) => void;
  labels?: { from: string, to: string };
}

export const CustomDateSelector: React.FC<CustomDateSelectorProps> = ({ 
  filterId, 
  customDates, 
  updateCustomDate,
  labels = { from: 'From', to: 'To' }
}) => {
  const defaultRange = { 
    start: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], 
    end: new Date().toISOString().split('T')[0] 
  };
  const dates = {
    start: customDates[filterId]?.start || defaultRange.start,
    end: customDates[filterId]?.end || defaultRange.end
  };
  
  return (
    <div className="flex items-center gap-2 mt-2 p-2 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-100 dark:border-slate-700 animate-in fade-in slide-in-from-top-1 duration-200">
      <div className="flex flex-col gap-0.5">
        <label className="text-[10px] font-bold text-slate-400 uppercase">{labels.from}</label>
        <div className="flex items-center gap-1.5">
          <Calendar size={10} className="text-slate-400" />
          <input 
            type="date" 
            value={dates.start}
            onChange={(e) => updateCustomDate(filterId, 'start', e.target.value)}
            className="bg-transparent border-none text-xs font-bold text-slate-700 dark:text-slate-200 outline-none cursor-pointer focus:ring-0 p-0"
          />
        </div>
      </div>
      <div className="w-px h-6 bg-slate-200 dark:bg-slate-700 mx-1"></div>
      <div className="flex flex-col gap-0.5">
        <label className="text-[10px] font-bold text-slate-400 uppercase">{labels.to}</label>
        <div className="flex items-center gap-1.5">
          <Calendar size={10} className="text-slate-400" />
          <input 
            type="date" 
            value={dates.end}
            onChange={(e) => updateCustomDate(filterId, 'end', e.target.value)}
            className="bg-transparent border-none text-xs font-bold text-slate-700 dark:text-slate-200 outline-none cursor-pointer focus:ring-0 p-0"
          />
        </div>
      </div>
    </div>
  );
};
